import { Dialog } from '@mui/material';
import React from 'react';
import { subHeadingStyle } from 'views/pages/manage/unAssigned/studentFinanceApproval/epmrCancellation/constant';
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import { grnModule } from './constant';
import { ReactComponent as DownloadIcon } from "assets/img/svg/downloadBlackV2.svg";
import { ToExcel } from '../../../../common/commonComponents';

const PoSerialItemListing = ({ open,
  setOpen,
  rows,
  listingKey,
  title = "PO Listing",
  clickSearchHandler = () => { },
  warningData,
  yearKey,
  grnType,
  vendorKey,
  receivingVendorKey,
  activePlant,
  globalFilter
}) => {
  const closeDialog = () => {
    setOpen(false);
  }

  const searchHandler = ({ value, year }) => {
    let payload = {
      [grnType?.value === "101" ? "poNumber" : grnType?.value === '102' ? "docNo" : grnType?.value === 'pendingScreen' ? "uuid" : ""]: value,
      ...(year && { year: year }),
      processType: grnModule,
    };
    payload.plant = globalFilter?.plant?.length > 0 ? [globalFilter?.plant[0]?.value] : activePlant?.map(p => p?.value);
    clickSearchHandler(payload);
  };

  const exportData = rows?.map(item => ({
    [listingKey]: item?.[listingKey] || '',
  })) || [];

  const detailObj = { [listingKey]: listingKey };

  return (
    <Dialog open={open} fullwidth maxWidth="300px">
      <div className="p-4 confirm-rejection-dialog">
        <div className="d-flex justify-content-end">
          <CrossIcon onClick={closeDialog} />
        </div>
        <div style={{ width: '500px' }}>
          <div className="d-flex justify-content-center align-items-center ">
            <div className="header">{title}</div>
            {listingKey == 'serialNo' &&
              <div>
                <ToExcel
                  data={exportData}
                  detailObj={detailObj}
                  name={`Serial Numbers`}
                  filename={`${title}`}
                />
              </div>
            }
          </div>
          <table className="table table-striped">
            <tr>
              {
                warningData ? <td className='mt-1 d-flex justify-content-center cursor link'>{warningData}</td> : rows?.map((item, index) => (
                  <td style={subHeadingStyle} className='mt-1 d-flex justify-content-center cursor link' onClick={() => searchHandler({
                    value: item?.[listingKey],
                    year: item?.[yearKey] || undefined,
                  })} key={`${item?.[listingKey]}-${index}`}>{
                      item?.[listingKey]}
                    &nbsp;
                    {yearKey && item?.[yearKey] ? `(${item?.[yearKey]})` : ""}
                    {(receivingVendorKey && item?.[receivingVendorKey]) || (vendorKey && item?.[vendorKey]) ? (
                      ` [${[
                        item?.[receivingVendorKey],
                        item?.[vendorKey]
                      ].filter(Boolean).join(', ')}]`
                    ) : ""}                     </td>
                ))
              }
            </tr>
          </table>

        </div>
      </div>
    </Dialog>
  );

}
export default PoSerialItemListing